module.exports = __webpack_public_path__ + "static/img/app.3b49a0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app.png
// module id = 9720
// module chunks = 5